export const BASE_URL = 'https://xlario.yourhonour.tv/api/';
// export const BASE_URL = 'http://192.168.0.136:3003/api/';

